import $ from 'jquery';
import createStickySidebars from 'global/plugins/sticky-sidebar';

window.DocStyle = {
  setupPostIt() {
    const head = '<span class="post-it-corner" /><h3 class="post-it-title">TIP</h3>';
    $('p.tip').each((_, el) => {
      const $this = $(el);
      $this.wrapAll('<aside class="post-it" />');
      $this.before(head);
      $this.removeClass('tip');
    });
  },

  setupDividerRings() {
    // Next chapters sections
    const docContainer =
      '<section class="c-section u-bg-color-grayscale--lightsmoke c-docs-api__chapter" data-js-api-reference-section><div class="o-container o-grid"><div class="o-grid__row js-sticky-container"><div class="o-grid__item o-grid__item--@sm9"><div class="documentation u-typescale u-typescale--docs" data-js-docs-article-content></div></div><div class="o-grid__item o-grid__item--@sm3"><div class="c-sidebar-wrapper" data-append-toc-menu></div></div></div></div></section>';
    $('[data-js-docs-article-content] > h1:not(:first)').each((_, el) => {
      const $this = $(el);
      const nextMainDocChapter = $this.nextAll().addBack();
      const topContainer = $this.parents('[data-js-article-initial-chapter]');

      // Adds drawer icon before title text
      const icon =
        '<svg class="ai ai-48dp ai-va-middle u-m-r-large ai-drawer"><use xlink:href="#ai-drawer"></use></svg>';
      $this.prepend(icon);

      topContainer.after(docContainer);
      topContainer.next().find('[data-js-docs-article-content]').html(nextMainDocChapter);
    });
  },

  setupInlineToc() {
    const sidebarOffsetTop = $('[data-stickysidebar]').data('offset-top');
    const sidebarOffsetBottom = $('[data-stickysidebar]').data('offset-bottom');

    const inlineTOCHeading = '<h2 class="toc-menu-title u-sr-only">In this section</h2>';
    const $appendTOCMenu = $('[data-append-toc-menu]');

    $('.inline-toc').each((_, el) => {
      const $this = $(el);
      $this.before(inlineTOCHeading);

      const stuff = $this.prev().addBack();

      // Instantiates the inline menu below the title
      stuff.clone().insertAfter($this.prev()).wrapAll('<div class="toc-menu" />');

      // Creates the new sidebar
      $this.addClass('c-sidebar__nav').attr('data-local-nav-menu', '');
      $appendTOCMenu.append(stuff);
      $appendTOCMenu.wrapInner(
        `<aside class="c-sidebar" data-toc-menu data-sticky-el data-offset-top="${sidebarOffsetTop}" data-offset-bottom="${sidebarOffsetBottom}">
           <div class="c-sidebar__inner"></div>
         </aside>`,
      );
    });

    // re-instantiate sidebar instances to accommodate this new one
    createStickySidebars();
  },

  setupDefinitionList() {
    $('div > dl, div > div[lang] > dl').each((_, el) => {
      const $this = $(el);
      if ($this.parents('.definition-list-group').length === 0) {
        const dlGroup = $this.nextUntil(':not(dl)').addBack();
        dlGroup.wrapAll('<div class="definition-list-group" />');
        dlGroup.find('dt').each((__, dt) => {
          $(dt).next().addBack().wrapAll('<div class="definition-list-row" />');
        });
      }
    });
  },

  setupBlueSeparator() {
    const separator = $('[data-js-api-doc-separator]');
    const apiReferenceContainer = $('[data-js-api-reference-section]');

    if (typeof apiReferenceContainer !== 'undefined') {
      separator.detach();
      separator.removeClass('hidden');
      apiReferenceContainer.before(separator);
    } else {
      separator.remove();
    }
  },
};
